// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import Description from '../../ui-helper-elements/Description'
// Asset Imports

export default function MonthlyHeader() {
   const state = useQuoteContext()
   const { getString, getFormattedString } = state

   return (
      <div className='row'>
         <h5 className='col-bhr1'>{getString('global.Monthly')}</h5>
         <h5 className='col-bhr2'>{getString('global.Qty')}</h5>
         <h5 className='col'>{getString('global.Volume')}</h5>
         <h5 className='col'>
            {state.hasUSEmployees == true || state.user_view == 'Internal'
               ? getString('global.Bundle')
               : ''}
         </h5>
         <h5 className='col'>{getString('global.PEPM')}</h5>
         <h5 className='col'>{getString('global.Final')}</h5>
         {state.differenceQuote && (
            <>
               {state.previousCurrencyCode != state.currencyCode ? (
                  <Description
                     className='col col-bhr-blue'
                     title='Estimation Disclaimer'
                     content={
                        <div
                           dangerouslySetInnerHTML={{
                              __html: getFormattedString(
                                 'product.MonthlyHeader.Disclaimer',
                                 {
                                    previousCurrencyCode:
                                       state.previousCurrencyCode,
                                    currencyCode: state.currencyCode,
                                    update_dt: state.currencyObject.Update_dt,
                                 },
                              ),
                           }}
                        />
                     }
                     placement='bottom'
                  >
                     <span
                        className={
                           state.previousCurrencyCode != state.currencyCode
                              ? 'hoverable'
                              : ''
                        }
                     >
                        <h5 className='col col-bhr-blue'>
                           {getString('global.Previous')}
                        </h5>
                     </span>
                  </Description>
               ) : (
                  <h5 className='col col-bhr-blue'>
                     {getString('global.Previous')}
                  </h5>
               )}
               <h5 className='col'>{getString('global.Difference')}</h5>
               {process.env.REACT_APP_ENVIRONMENT == 'staging' && (
                  <h5 className='col'>
                     {getString('product.MonthlyHeader.SalesMRR')}
                  </h5>
               )}
            </>
         )}
      </div>
   )
}
